import styled from "styled-components";
import ConfirmButton from "features/shared/components/buttons/ConfirmButton.styled";
import OutlinedButton from "features/shared/components/buttons/OutlinedButton.styled";

const QuestionsCard = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  margin-top: 24px;
  max-width: 550px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};

  ${ConfirmButton}, ${OutlinedButton} {
    margin-top: 24px;
  }

  ${ConfirmButton} {
    width: 100%;
  }
`;

export default QuestionsCard;
